// extracted by mini-css-extract-plugin
module.exports = {"viewMenu":"ViewMenu_viewMenu__6WTUW"};